import React from "react";
import { useHistory } from "react-router-dom";

import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles(theme => ({
  paper: {
    textAlign: 'center',
    backgroundColor: '#00b2ad',
    color: '#fff',
  },
  grid1: {
    backgroundColor: '#ecebea',
    backgroundSize: 'cover',
  },
  grid2: {
    paddingTop: theme.spacing(5),
    paddingLeft: theme.spacing(5),
    paddingBottom: theme.spacing(5),
    paddingRight: theme.spacing(5),
  },
  caption: {
    backgroundColor: '#000',
    color: "#fff",
    textAlign: 'center',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    fontWeight: '600'
  },
}));

export default (props) => {
  const history = useHistory();
  if (props.isAuthenticated) {
    history.push("/event");
  }
  const handleRegister = async (event) => {
    history.push("/register");
  }
  const classes = useStyles();
  return (
    <div className='container-home'>
      <Grid container direction="row" justify="center">
        <Grid item xs={9}>
          <Paper className={classes.paper}>
            <Grid container direction="row">
              <Grid item md={5}  className={classes.grid1} style={{backgroundImage: `url("${props.config.homePanel.imageUrl}")`}}>
              </Grid>
              <Grid item md={7} className={classes.grid2}>
                <h1 style={{ marginBottom: '3px', letterSpacing: '1px' }}>{props.config.homePanel.title}</h1>
                <h3 style={{ marginBottom: '12px' }}>{props.config.homePanel.subtitle}</h3>
                <h3>{props.config.homePanel.eventDate}</h3>
                <h4 style={{ marginBottom: '24px' }}>{props.config.homePanel.description}</h4>
                <Button color="secondary" variant="contained" onClick={handleRegister}>Register Now</Button>
              </Grid>
            </Grid>
          </Paper>

        </Grid>
      </Grid>
    </div>
  );
};